import React from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import { Warning } from "@material-ui/icons";
import { Button, makeStyles } from "@material-ui/core";

const duplicateActivityAlertStyle = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:focus-visible": {
      outline: "none !important",
    },
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: theme.spacing(1),
    "&:focus-visible": {
      outline: "none !important",
    },
  },
  bodyWrapper: {
    padding: "24px",
    textAlign: "center",
    outline: "none !important",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "500px",
    color: "var(--dark_blue)",
    "&: focus-visible": {
      outline: "none !important",
    },
  },
    ButtonWrapper: {
        display: 'flex', 
        gap: '10px', 
        justifyContent: 'flex-end', 
        alignItems: 'center', 
        borderTop: '1px solid #f5f1f1', 
        paddingTop: '20px', 
        width: '100%'
    },
  closeButton: {
    cursor:'pointer',
    padding: '4px 15px !important',
    minWidth: "75px !important",
    height:'35px !important',
    borderRadius:'4px !important',
    textTransform: 'capitalize !important',
    color: 'var(--red) !important',
    border: '1px solid var(--red) !important',
    fontWeight:"600 !important",
     backgroundColor: "transparent !important",
    "&:focus, &:hover": {
      color: 'var(--red) !important',
      backgroundColor: "transparent !important",
    },
  },
   proceedButton: {
    border: 'none',
    cursor:'pointer',
    padding: '4px 15px !important',
    minWidth: "75px !important",
    height:'37px !important',
    borderRadius:'4px !important',
    textTransform: 'capitalize !important',
    color: '#ffffff !important',
    fontWeight:"600 !important",
    backgroundColor: "var(--accent-color) !important",
    "&:focus, &:hover": {
      color: '#ffffff !important',
      backgroundColor: "var(--accent-color) !important",
    },
  },
}));

const DuplicateActivityAlert = ({ open, onClose, message = "", handleSubmit=() => {}}) => {
  const classes = duplicateActivityAlertStyle();

  return (
    <div>
      <Modal
        className={classes.modal}
        open={open}
        onClose={() => {}}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
          <div className={classes.paper}>
            <div className={classes.bodyWrapper}>
              <Warning style={{ color: "var(--red)", fontSize: 72 }} />
             
              {message && (
                <span style={{ fontSize: "14px", marginBottom: "20px",color: 'var(--red)' }}>
                {message}
              </span>
            )}
              <span style={{ fontSize: "14px", marginBottom: "20px", }}>
               You can still add this one if that’s what you intend — would you like to continue? 
              </span>
              <div className={classes.ButtonWrapper}>
                <Button  onClick={onClose} className={classes.closeButton}>
                Close
              </Button>
               <Button  onClick={handleSubmit} className={classes.proceedButton}>
                Proceed Anyway
              </Button>
              </div>
            </div>
          </div>
      </Modal>
    </div>
  );
};
export default DuplicateActivityAlert;
